(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoter-factory-story"] && !Shopify.designMode) return;
  try {
    
  const initZoterFactory = (scope = document) => {
    scope.querySelectorAll('[data-zoter-factory]').forEach((section) => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';
      const stage = section.querySelector('[data-factory-stage]');
      const canvas = section.querySelector('[data-factory-canvas]');
      const desktopQuery = matchMedia('(min-width: 990px)');
      const syncScale = () => {
        if (!stage || !canvas) return;
        if (!desktopQuery.matches) {
          section.style.removeProperty('--factory-scale');
          canvas.style.removeProperty('--factory-scale');
          stage.style.removeProperty('height');
          return;
        }
        const scale = Math.min(stage.clientWidth / 1600, 1);
        section.style.setProperty('--factory-scale', scale.toString());
        canvas.style.setProperty('--factory-scale', scale.toString());
        stage.style.height = `${canvas.scrollHeight * scale}px`;
      };
      const scaleObserver = new ResizeObserver(syncScale);
      scaleObserver.observe(stage);
      desktopQuery.addEventListener('change', syncScale);
      requestAnimationFrame(syncScale);
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        section.classList.add('is-visible');
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.18 });
      observer.observe(section);
    });
  };

  initZoterFactory();
  document.addEventListener('shopify:section:load', (event) => initZoterFactory(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoter-intro-showcase"] && !Shopify.designMode) return;
  try {
    
  const initZoterIntro = (scope = document) => {
    scope.querySelectorAll('[data-zoter-intro]').forEach((section) => {
      if (section.dataset.introReady === 'true') return;
      section.dataset.introReady = 'true';
      const panels = [...section.querySelectorAll('[data-intro-panel]')];
      const mobileQuery = matchMedia('(max-width: 989px)');
      const reducedMotionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      const navigationReady = new WeakMap();
      panels.forEach((panel) => navigationReady.set(panel, panel.classList.contains('is-active')));
      const activate = (panel) => {
        panels.forEach((item) => {
          const active = item === panel;
          const wasActive = item.classList.contains('is-active');
          if (!active || !wasActive) navigationReady.set(item, false);
          item.classList.toggle('is-active', active);
          item.querySelector('[data-intro-trigger]')?.setAttribute('aria-expanded', active ? 'true' : 'false');
          if (active && reducedMotionQuery.matches) navigationReady.set(item, true);
        });
      };
      panels.forEach((panel) => {
        const trigger = panel.querySelector('[data-intro-trigger]');
        trigger?.addEventListener('click', () => activate(panel));
        trigger?.addEventListener('focus', () => activate(panel));
        panel.addEventListener('transitionstart', (event) => {
          if (mobileQuery.matches && event.target === panel && event.propertyName === 'min-height') {
            navigationReady.set(panel, false);
          }
        });
        panel.addEventListener('transitionend', (event) => {
          if (
            mobileQuery.matches &&
            event.target === panel &&
            event.propertyName === 'min-height' &&
            panel.classList.contains('is-active')
          ) {
            navigationReady.set(panel, true);
          }
        });
        panel.addEventListener('click', (event) => {
          const imageLink = event.target.closest('.zoter-intro__image-link');
          if (mobileQuery.matches && imageLink) {
            const canNavigate = panel.classList.contains('is-active') && navigationReady.get(panel) === true;
            if (!canNavigate) {
              event.preventDefault();
              if (!panel.classList.contains('is-active')) activate(panel);
              return;
            }
          }
          if (!panel.classList.contains('is-active') && !event.target.closest('a')) activate(panel);
        });
        panel.addEventListener('mouseenter', () => {
          if (matchMedia('(hover: hover)').matches) activate(panel);
        });
      });
    });
  };

  initZoterIntro();
  document.addEventListener('shopify:section:load', (event) => initZoterIntro(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoter-project-gallery"] && !Shopify.designMode) return;
  try {
    
  const initZoterProjectLightboxes = (scope = document) => {
    scope.querySelectorAll('[data-zoter-projects]').forEach((section) => {
      if (section.dataset.lightboxReady === 'true') return;
      section.dataset.lightboxReady = 'true';

      const dialog = section.querySelector('[data-project-lightbox]');
      const projects = [...section.querySelectorAll('.zoter-projects__group:not([aria-hidden]) [data-project-lightbox-trigger]')];
      const triggers = [...section.querySelectorAll('[data-project-lightbox-trigger]')];
      const image = dialog?.querySelector('[data-project-lightbox-image]');
      const title = dialog?.querySelector('[data-project-lightbox-title]');
      const location = dialog?.querySelector('[data-project-lightbox-location]');
      if (!dialog || !image || !title || !location || !projects.length) return;

      let currentIndex = 0;
      let activeTrigger;

      const showProject = (index) => {
        currentIndex = (index + projects.length) % projects.length;
        const project = projects[currentIndex];
        image.src = project.dataset.projectImage;
        image.alt = project.dataset.projectTitle;
        title.textContent = project.dataset.projectTitle;
        location.textContent = project.dataset.projectLocation;
        location.hidden = !project.dataset.projectLocation;
      };

      const open = (trigger) => {
        activeTrigger = trigger;
        showProject(Number(trigger.dataset.projectIndex));
        dialog.showModal();
      };

      triggers.forEach((trigger) => trigger.addEventListener('click', () => open(trigger)));
      dialog.querySelector('[data-project-lightbox-close]')?.addEventListener('click', () => dialog.close());
      dialog.querySelector('[data-project-lightbox-previous]')?.addEventListener('click', () => showProject(currentIndex - 1));
      dialog.querySelector('[data-project-lightbox-next]')?.addEventListener('click', () => showProject(currentIndex + 1));
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') showProject(currentIndex - 1);
        if (event.key === 'ArrowRight') showProject(currentIndex + 1);
      });
      dialog.addEventListener('close', () => activeTrigger?.focus());
    });
  };

  initZoterProjectLightboxes();
  document.addEventListener('shopify:section:load', (event) => initZoterProjectLightboxes(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoter-shoppable-scenes"] && !Shopify.designMode) return;
  try {
    
  const initZoterScenes = (scope = document) => {
    scope.querySelectorAll('[data-zoter-scenes]').forEach((section) => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';
      const viewport = section.querySelector('[data-scene-viewport]');
      const slides = [...section.querySelectorAll('[data-scene-slide]')];
      const dots = [...section.querySelectorAll('[data-scene-dot]')];
      if (!viewport || !slides.length) return;
      let activeIndex = 0;
      let timer;

      const setActive = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === activeIndex));
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      };

      const show = (index, behavior = 'smooth') => {
        setActive(index);
        const slide = slides[activeIndex];
        viewport.scrollTo({ left: slide.offsetLeft - (viewport.clientWidth - slide.clientWidth) / 2, behavior });
      };

      const syncActiveFromScroll = () => {
        const viewportCenter = viewport.scrollLeft + viewport.clientWidth / 2;
        let nearestIndex = 0;
        let nearestDistance = Infinity;
        slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
          const distance = Math.abs(viewportCenter - slideCenter);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });
        setActive(nearestIndex);
      };

      const start = () => {
        clearInterval(timer);
        if (section.dataset.autoplay !== 'true' || slides.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = setInterval(() => show(activeIndex + 1), Number(section.dataset.interval));
      };

      section.querySelector('[data-scene-previous]')?.addEventListener('click', () => { show(activeIndex - 1); start(); });
      section.querySelector('[data-scene-next]')?.addEventListener('click', () => { show(activeIndex + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.index)); start(); }));
      viewport.addEventListener('scrollend', () => { syncActiveFromScroll(); start(); });
      viewport.addEventListener('touchstart', () => clearInterval(timer), { passive: true });
      section.addEventListener('mouseenter', () => clearInterval(timer));
      section.addEventListener('mouseleave', start);
      section.addEventListener('focusin', () => clearInterval(timer));
      section.addEventListener('focusout', start);
      show(0, 'auto');
      start();
    });
  };

  initZoterScenes();
  document.addEventListener('shopify:section:load', (event) => initZoterScenes(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoter-testimonials"] && !Shopify.designMode) return;
  try {
    
  const initZoterTestimonials = (scope = document) => {
    scope.querySelectorAll('[data-zoter-testimonials]').forEach((carousel) => {
      if (carousel.dataset.ready === 'true') return;
      carousel.dataset.ready = 'true';
      const slides = [...carousel.querySelectorAll('[data-testimonial-slide]')];
      const dots = [...carousel.querySelectorAll('[data-testimonial-dot]')];
      if (slides.length < 2) return;
      let activeIndex = 0;
      let pointerStart = 0;

      const showSlide = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === activeIndex;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      };

      carousel.querySelector('[data-testimonial-prev]')?.addEventListener('click', () => showSlide(activeIndex - 1));
      carousel.querySelector('[data-testimonial-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => showSlide(Number(dot.dataset.slideIndex))));
      carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') showSlide(activeIndex - 1);
        if (event.key === 'ArrowRight') showSlide(activeIndex + 1);
      });
      carousel.addEventListener('pointerdown', (event) => { pointerStart = event.clientX; });
      carousel.addEventListener('pointerup', (event) => {
        const distance = event.clientX - pointerStart;
        if (Math.abs(distance) < 50) return;
        showSlide(activeIndex + (distance < 0 ? 1 : -1));
      });
    });
  };

  initZoterTestimonials();
  document.addEventListener('shopify:section:load', (event) => initZoterTestimonials(event.target));

  } catch(e) { console.error(e); }
})();
})();
